import { AWAITING_SHIPMENT_ID } from '../orders-page-view-constants';

export const buildTagProps = (item) => {
  const { routePath, id, parentId, storeGuid } = item;
  if (routePath) {
    return {
      to: `/orders/${routePath}`,
    };
  }
  return {
    to: storeGuid ? `/orders/${parentId}/store/${storeGuid}` : `/orders/${id}`,
  };
};

export const getViewToHighlight = (history = {}) => {
  if (history.location && history.location.pathname) {
    const path = history.location.pathname;
    return path.replace('/orders/', '').replace('/store/', '-');
  }
  return AWAITING_SHIPMENT_ID;
};
